let initialState = {
  enteredPlannedValue: {
    dashboard_widget: { data: null },
    template_widget: { data: null },
    widgetMaker: { data: null },
    preview: { data: null },
  },
};
const PlannedValue = (state = initialState, action) => {
  switch (action.type) {
    case "SET_ENTERED_PLANNED_VALUE":
      return {
        ...state,
        enteredPlannedValue: action.payload,
      };
    default:
      return state;
  }
};

export default PlannedValue;
